module.exports = __webpack_public_path__ + "static/bg.42669f3c.png";